import { Formatters, Messages } from '../../../../../gen-src/Localize';

export interface MessageWithAndWithoutCount {
  readonly withCount: (a: { count: string }) => string;
  readonly withoutCount: () => string;
}

export function messageWithOrWithoutCount(count: number | null, bothMessages: MessageWithAndWithoutCount): string {
  return count != null
    ? bothMessages.withCount({ count: Formatters.formatCount(count) })
    : bothMessages.withoutCount();
}

export function getFilteredCountRatio(filteredCount: number | null, unfilteredCount: number | null): string | null {
  return filteredCount != null && unfilteredCount != null ?
      Messages.XOutOfN({countX: Formatters.formatCount(filteredCount),
        countN: Formatters.formatCount(unfilteredCount)}) : null;
}
